import { Cookies } from 'react-cookie';

import { DevicesOnMapResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getDevicesOnMap = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/traps/floor/${slug}`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as DevicesOnMapResponse;
};
